import PropTypes from 'prop-types';
import { Form } from 'antd';
import { actionInputs, fieldComponents } from '../constants/mobileFormConstants';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { checkFieldValue } from '../constants/fieldValidators';
import { mobileFormFieldsTypes } from '../../../config/constants/mobileFormConstant';

export const FormItems = ({ formFields, values, onChange: onChangeValue, nodeHierarchy = [], disabled }) => {
  const { translate: t } = useDictionaryTranslation();

  const getRules = (field) => {
    const itemRules = [];
    itemRules.push({
      required: field.obligatory,
      validator: async (_, value) => {
        const error = checkFieldValue(field, value);
        if (error != null) {
          throw new Error(t(error.message));
        }
        return true;
      },
    });
    return itemRules;
  };

  const getFieldComponent = (field) => {
    if (field.id === mobileFormFieldsTypes.action.id) {
      return actionInputs[field.typeAction?.id] ?? actionInputs.default;
    }
    return fieldComponents[field.id] ?? fieldComponents.default;
  };

  return formFields.map((field) => {
    const fieldComponent = getFieldComponent(field);
    if (fieldComponent == null) return null;
    const Component = fieldComponent.component;
    if (fieldComponent.nonInput) {
      return <Component key={field.idInput} field={field} />;
    }
    return (
      <Form.Item
        key={field.idInput}
        label={fieldComponent.hideLabel ? null : field.label}
        name={field.idInput}
        rules={getRules(field)}
        initialValue={values[field.idInput]}
      >
        <Component
          field={field}
          value={values[field.idInput]}
          onChange={(value) => {
            onChangeValue(field.idInput, value);
          }}
          disabledField={disabled}
          renderFormItems={FormItems}
          nodeHierarchy={nodeHierarchy}
        />
      </Form.Item>
    );
  });
};

FormItems.propTypes = {
  formFields: PropTypes.arrayOf(
    PropTypes.shape({
      idInput: PropTypes.string,
      label: PropTypes.string,
      obligatory: PropTypes.bool,
      list: PropTypes.array,
    }),
  ),
  values: PropTypes.object,
  onChange: PropTypes.func,
  nodeHierarchy: PropTypes.array,
  disabled: PropTypes.bool,
};
